import * as model from './models';

import createAxios from '@framework/http';
const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.KS_ENV !== 'prod' });

/** Item Dispatch Controller  将货架商品加入小黄车 */
export async function addItemUsingPOST(params: { param: model.IItemOpParam; shopId: string }) {
    const result = await axios.post<model.IMessageItemOpRetVO>(`/rest/op/vc/item/seller/dispatch/add`, {
        ...params.param,
    });
    return result;
}

/** Item Dispatch Controller  从售卖渠道（默认小黄车）获取商品列表，支持根据商品ID、商品名称进行查询 */
export async function listItemUsingPOST(params: { param: model.IDispatchItemPageParam; shopId: string }) {
    const result = await axios.post<model.IMessageDispatchItemListVO>(`/rest/op/vc/item/seller/dispatch/list`, {
        ...params.param,
    });
    return result;
}

/** Item Dispatch Controller  查询挂车各维度的数量 */
export async function dispatcherNumUsingPOST(params: { param: model.IDispatcherNumParam; shopId: string }) {
    const result = await axios.post<model.IMessageDispatcherNumVO>(`/rest/op/vc/item/seller/dispatch/num`, {
        ...params.param,
    });
    return result;
}

/** Item Dispatch Controller  将小黄车商品移除 */
export async function removeItemUsingPOST(params: { param: model.IItemOpParam; shopId: string }) {
    const result = await axios.post<model.IMessageItemOpRetVO>(`/rest/op/vc/item/seller/dispatch/remove`, {
        ...params.param,
    });
    return result;
}
